"use strict";

/**
 * Предоставляет инструменты для работы с Агентом веб-доступа через HTTP. Например, получить адрес Агент веб-доступа.
 *
 * @namespace WebAccess.agent.transport.HTTP
 * @since 5.1.0.1500
 */
(function (global) {
  var HTTP = global.agent.transport.BaseTransport.extend({
    className: 'HTTP',
    name: 'HTTP',
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function () {
      this._super();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**    
   /**
    * Запускает Агент веб-доступа по URI-схеме.
    * После запуска во всех браузерах, отличных от Internet Explorer, проверяется соединение с Агентом. 
    * Если Агент не отвечает, он считается недоступным.    
    * @method  WebAccess.agent.transport.HTTP.start
    * @return {Deferred} Специальный deferred-объект.
    * @since 5.1.0.1500
    */
    start: function () {
      var me = this;
      me._super();

      return me._run(me._getSessionID());
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**    
   /**
    * Перезапускает Агент веб-доступа по URI-схеме.
    * После запуска во всех браузерах, отличных от Internet Explorer, проверяется соединение с Агентом.
    * Если Агент не отвечает, он считается недоступным.    
    * @method  WebAccess.agent.transport.HTTP.restart
    * @return {Deferred} Специальный deferred-объект.
    * @since 5.1.0.1500
    */
    restart: function () {
      var me = this;
      me._super();
      return me._run('RESTART&' + me._getSessionID());
    },

    /**
     * Получает ИД сессии веб-доступа.
     *
     * @method  WebAccess.agent.transport.HTTP._getSessionID
     * @return {string} ИД сессии Агента веб-доступа.
     * @since 5.4.0.1011
     */
    _getSessionID: function () {
      if (typeof g_UserContextID !== "undefined") {
        return g_UserContextID;
      }
      return '';
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Запускает агента по URI схеме с параметром param 
    * @private
    */
    _run: function (param) {
      var me = this;
      me._super();
      log.info('AGENT', 'Starting HTTP transport');

      var uri = "waagent54:" + param;
      log.info('AGENT', 'Launched URL Schema: ' + uri);

      if (WA.ENV.engine.name.toLowerCase() === 'webkit') {
        this._startInWebKit(uri);
      } else {
        switch (WA.ENV.browser.name.toLowerCase()) {
          case 'firefox':
            this._startInFirefox(uri);
            break;
          default:
            this._startDefault(uri);
            break;
        }
      }

      return me.waitForStart();
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Останавливает работу Агента веб-доступа.
    *
    * @method  WebAccess.agent.transport.HTTP.stop
    * @return {WebAccess.agent.transport.HTTP} Объект типа HTTP.
    * @since 5.1.0.1500
    */
    stop: function () {
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает адрес сервера Агента в зависимости от используемого протокола веб-доступа.
    *
    * @method  WebAccess.agent.transport.HTTP.getAgentServerUrl
    * @return {string} Адрес сервера Агента веб-доступа.
    * @since 5.1.0.1516
    */
    getAgentServerUrl: function () {
      // HACK: Edge не доверяет агенту по http, поэтому всегда используем https.
      if (window.location.protocol === 'https:' || WA.ENV.browser.name.toLowerCase() === 'edge') {
        return 'https://localhost:9654';
      } else {
        return 'http://localhost:9554';
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Оправка служебных асинхронных запросов агенту. Например, GetSessionRegistrationStatus.
    * Метод вынесен отдельно для возможности подмены его в тестах.
    * @private
    */
    _send: function (params) {
      var me = this;
      return $.ajax({
        timeout: 2000,
        type: 'GET',
        url: me.getAgentServerUrl(),
        data: params,
        cache: false
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**    
     * Отправляет запрос Агенту веб-доступа через HTTP-протокол (тип GET, заголовки CORS).
     * Сторона, отвечающая на запрос, должна отправить соответствующие заголовки запроса.
     * Если ответ на запрос не был получен, то вернется строка "CNA - connection not available".
     *
     * @method WebAccess.agent.transport.HTTP.call    
     * @param  {string} requestName Имя запроса
     * @param  {string} pluginName Имя плагина Агента, к которому идет обращение. 
     * Для базовых вызовов к ядру Агента веб-доступа передается пустая строка
     * @param  {object} params Параметры запроса
     * @return {object} Результат запроса.
     * @since 5.1.0.1500
     */
    call: function (requestName, pluginName, params, ajaxParams) {

      var d = $.Deferred();

      var me = this;
      var error = '';
      params.method = requestName;
      params.plugin = pluginName;

      var resultAjaxParams = $.extend({}, ajaxParams, {
        type: 'GET',
        url: me.getAgentServerUrl(),
        async: true,
        cache: false,
        data: params
      });

      $.ajax(resultAjaxParams).done(function (res) {
        var respText = res;
        log.info('AGENT', '"Call" method result: requestName: ' + requestName + ' response:', respText);
        d.resolve(respText);
      }).fail(function (err) {
        log.info('AGENT', '"Call" method error: requestName: ' + requestName + ' error:', err);
        d.reject('CNA');
      });

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Открытие URI-схемы в Firefox
    * @method WebAccess.agent.transport.HTTP._startInFirefox
    * @private
    * @return {WebAccess.agent.transport.HTTP}
    * @since 5.1.0.1500
    */
    _startInFirefox: function (url) {
      var me = this;
      // Создаем скрытый фрейм, в котором пытаемся открыть наш URL
      var frame = document.createElement('iframe');
      frame.style.display = 'none';
      frame = document.body.appendChild(frame);

      try {
        frame.contentWindow.location = url;
      } catch (e) {
      }
      // Удаляем наш временный фрейм
      document.body.removeChild(frame);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Открытие URI-схемы в Chrome, Safari
    * К сожалению в отличие от FF хром выводит окошко асинхронно и что там решилось
    * мы от браузера узнать не можем, и поэтому атакуем агента с надеждой на 
    * ответ.
    * @method WebAccess.agent.transport.HTTP._startInWebKit
    * @private
    * @since 5.1.0.1500
    */
    _startInWebKit: function (url) {
      var me = this;
      // Если веб-доступ работает через HTTPS, то запрос из frame к waagent блокируются, поэтому меняем просто window.location.
      // Без setTimeout агент не всегда запускался по url-схеме в Chrome.
      setTimeout(function () {
        window.location = url;
      }, 100);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Открытие URI-схемы во всех остальных браузерах.
    * @method WebAccess.agent.transport.HTTP._startDefault
    * @private
    * @since 5.1.0.1500
    */
    _startDefault: function (url) {
      var me = this;
      // Создаем скрытый фрейм, в котором пытаемся открыть наш URL
      var frame = document.createElement('iframe');
      frame.style.display = 'none';
      frame = document.body.appendChild(frame);
      frame.contentWindow.location = url;
      setTimeout(function () {
        try {
          // Пытаемся поработать с не определенным атрибутом фрейма
          // (вместо something можно использовать что-угодно)
          if (frame.contentWindow.location != 'something') {
            $.noop();
          }
        } catch (e) {
        }

        // Удаляем наш временный фрейм
        document.body.removeChild(frame);
      }, 0);
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//       
  });

  var http = new HTTP();
  global.agent.transport.HTTP = http;

  global.agent.transport.httpReady.resolve();
})(window.WebAccess);